// header-fixed-watcher.client

export default defineNuxtPlugin((nuxtApp) => {
  // const { y }      = useWindowScroll()
  // const yThrottled      = useThrottle(y, 100)      // 10 fps
  // const io         = useIOStore()

  const { $windowScroll, $viewport, $io } = nuxtApp


  // Determine when and what should be used to determine if the header should be fixed
  // let fixedTriggerHeight = ref(0)
  
  // if(ioHeader.headerFixedTriggerType === 'value') {
  //   fixedTriggerHeight.value = ioHeader.headerFixedTriggerHeight;
  // } else if(ioHeader.headerFixedTriggerType === 'element') {
  //   // 1 pixel for now
  //   const element = document.querySelector(ioHeader.headerFixedTriggerElementSelector)
  //   if(element && element instanceof HTMLElement) {
  //     fixedTriggerHeight.value = element.offsetHeight
  //   } else {
  //     throw new Error('headerFixedTriggerElementSelector | Element not found')
  //   }
  // } else {
  //   throw new Error('Invalid headerFixedTriggerType')
  // }

  let fixedTriggerHeight = ref(0)


  // Single watcher – write to store
  watch($windowScroll.yThrottled, (val) => {
    // Add Conditional Logic here when needed.
    // const desktop = $viewport.w.value >= 1200
    // $io.headerFixed = desktop ? val > 64 : val > 48
    // console.log('yThrottled val', val)
    
    if (val > fixedTriggerHeight.value) {
      $io.headerFixed = true
    } else {
      $io.headerFixed = false
    }
  }, { immediate: true })

})